// @ts-strict-ignore
import { supportedCoinGeckoTokenMap } from "components/pages/prices/supported_coin_gecko";

export const getCoinGeckoId = (
  asset: string | undefined,
  additionalTokenMap = {}
) => {
  if (!asset) return "";
  const tokenMap = { ...supportedCoinGeckoTokenMap, ...additionalTokenMap };
  return tokenMap[asset.toLowerCase()]?.id ?? "";
};
